<template>
  <div id="app">

    <c_Head :public-data="publicData" :city-code="cityCode"></c_Head>
    <c_Banner :public-data="publicData"></c_Banner>


    <router-view :public-data="publicData"  :city-code="cityCode" v-if="publicDataStatus"></router-view>

    <c_Foot :public-data="publicData"></c_Foot>

  </div>
</template>

<script>
  import c_Head from '@/components/Head/Head'
  import c_Banner from '@/components/Banner/Banner'
  import c_Foot from '@/components/Foot/Foot'
export default {
  name: 'App',
  components:{c_Head,c_Banner,c_Foot},
  data(){
    return {
      cityCode:'',
      publicData:{},
      publicDataStatus:false
    };
  },
  created(){
    this.axios.defaults.baseURL = 'http://madmin.busbaoche.com/';
    this.getCityCode();
    var that = this;
    this.axios.interceptors.request.use(function (config) {
      if(config.params){
        config.params.cityCode = that.cityCode;
        config.params.webType = 'A';
      }
      if(config.data){
        config.data.cityCode = config.data.cityCode ? config.data.cityCode : that.cityCode;
        config.data.webType = config.data.webType ? config.data.webType : 'A';
        config.data.viewType = config.data.viewType ? config.data.viewType : '2';
      }
      return config;
    },function (error) {
      return Promise.reject(error);
    });
  },
  mounted(){
    this.getPublicData();
  },
  methods:{
    getCityCode:function(){
      if(this.$route.query.cityCode){
        this.cityCode = this.$route.query.cityCode;
      }
    },
    getPublicData:function () {
      var that = this;
      this.axios.get('HomeInfo', {
        params: {
          viewType:'2'
        }
      }).then(function (response) {
        console.log(response);
        // response.data.data.Name = '包车网';
        // response.data.data.CompanyName = '厦门特旅旅游客运有限公司';
        that.publicData=response.data.data;
        that.publicDataStatus = true;
        document.title = response.data.data.Name;
        document.querySelector('meta[name="keywords"]').setAttribute('content', response.data.data.Name);
        document.querySelector('meta[name="description"]').setAttribute('content', response.data.data.Name);
      }).catch(function (error) {
        console.log(error);

      });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue